export class MaxFolloweeError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "MaxFolloweeError";
  }
}